import { FeedbackRequestWithDetails } from '@/common/types/databaseTypes';
import { Box, Center, Flex, Loader, Text } from '@mantine/core';
import { FeedbackRequestCard } from '../utils/FeedbackCardRenderers';
import { useTranslation } from 'react-i18next';

interface ReceivedRequestsTabProps {
    receivedRequests: FeedbackRequestWithDetails[] | undefined;
    isLoadingReceivedRequests: boolean;
    notiParams: {
        workspaceName: string;
        workspaceImageUrl: string;
    };
}

/**
 * 받은 요청 탭 컴포넌트
 */
const ReceivedRequestsTab = ({
    receivedRequests,
    isLoadingReceivedRequests,
    notiParams,
}: ReceivedRequestsTabProps) => {
    const { t } = useTranslation(['feedback']);

    return (
        <>
            {isLoadingReceivedRequests ? (
                <Flex justify="center" align="center" h={200}>
                    <Loader />
                </Flex>
            ) : receivedRequests && receivedRequests.length > 0 ? (
                <Box
                    flex={1}
                    pr={16}
                    mr={16}
                    style={{ overflowY: 'auto' }}
                    className="custom-scrollbar"
                >
                    {receivedRequests.map(request => (
                        <FeedbackRequestCard
                            key={request.id}
                            request={request}
                            isReceived={true}
                            notiParams={notiParams}
                        />
                    ))}
                </Box>
            ) : (
                <Center h="100%" py="xl" ta="center">
                    <Text c="dimmed" mt="md">
                        {t('placeHolder.receivedRequest')}
                    </Text>
                </Center>
            )}
        </>
    );
};

export default ReceivedRequestsTab;
